// import React, { useState, useEffect } from "react";
import React, { useState, useEffect, useRef } from "react";
import AdminLeft from "./AdminLeft";
import TopBanner from "./TopBanner";
import Swal from "sweetalert2";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import "./fonts/NotoSansMalayalam-Regular-normal";

import { Editor } from "@tinymce/tinymce-react";

import Quill from "quill";
import "quill/dist/quill.snow.css";

export default function Visiting() {

  const [open, setOpen] = useState(true);

  // Sidebar auto collapse
  useEffect(() => {
    const handleResize = () => {
      setOpen(window.innerWidth >= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  const [formData, setFormData] = useState({
    name: "",
    bname: "",
    phone: "",
    age: "",
    sex: "",
    star: "",
    remarks: ""
  });

  const editorRef = useRef(null);
  const quillRef = useRef(null);

  useEffect(() => {
    if (!editorRef.current) return;

    // Prevent double initialization (React 19 Strict Mode)
    if (quillRef.current) return;

    const container = editorRef.current;

    quillRef.current = new Quill(container, {
      theme: "snow",
      modules: {
        toolbar: [
          ["bold", "italic", "underline"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link"],
          [{ align: [] }]
        ]
      }
    });

    // Set initial content
    quillRef.current.root.innerHTML = formData.prescription || "";

    // Listen for changes
    quillRef.current.on("text-change", () => {
      const html = quillRef.current.root.innerHTML;
      setFormData((prev) => ({ ...prev, prescription: html }));
    });

    // Cleanup (VERY IMPORTANT for React 19)
    return () => {
      quillRef.current = null;
    };
  }, []);



  const validateForm = () => {

    if (!form.phone) {
      return "Enter phone number to get details of the believer";
    }

    if (!/^\d{10}$/.test(form.phone)) {
      return "Phone Number must be 10 digits";
    }



    return null;
  };


  const [search, setSearch] = useState("");
  const [editId, setEditId] = useState(null);



  const handleSave = async () => {
    if (!formData.phone) {
      Swal.fire("Error", "Phone required", "warning");
      return;
    }

    const url = editId
      ? "https://kala.cubixsystems.com/api/update_visit.php"
      : "https://kala.cubixsystems.com/api/save_visit.php";

    try {
      // 🔄 STEP 1: SAVING
      Swal.fire({
        title: "Saving...",
        text: "Please wait",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading()
      });

      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...formData,
          id: editId
        })
      });

      const result = await res.json();

      if (!result.success) {
        Swal.fire("Error", "Failed to save data", "error");
        return;
      }

      // 🔄 STEP 2: GENERATING PDF
      Swal.update({
        title: "Generating PDF...",
        text: "Preparing document 📄"
      });

      const row = {
        visit_date: new Date().toISOString(),
        prescription: formData.prescription,
        name: formData.name
      };

      handlePrint(row); // optional print

      function getBase64Image(url) {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = "anonymous";

          img.onload = function () {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            resolve(canvas.toDataURL("image/png"));
          };

          img.onerror = reject;
          img.src = url;
        });
      }

      const doc = new jsPDF();


      doc.setFont("NotoSansMalayalam-Regular", "normal");

      const base64Image = await getBase64Image("/images/Astrologer.jpeg");

      const d = new Date(row.visit_date);
      const formattedDate = `${String(d.getDate()).padStart(2, "0")}-${String(
        d.getMonth() + 1
      ).padStart(2, "0")}-${d.getFullYear()}`;

      // Background
      doc.addImage(base64Image, "PNG", 0, 0, 210, 297);

      // Text
      doc.text(`Date: ${formattedDate}`, 125, 90);

      const splitText = doc.splitTextToSize(row.prescription || "", 160);
      doc.text(splitText, 50, 100);

      const pdfBlob = doc.output("blob");

      // 🔄 STEP 3: UPLOADING
      Swal.update({
        title: "Processing PDF...",
        text: "Please wait ☁️"
      });

      const formDataUpload = new FormData();
      formDataUpload.append("file", pdfBlob, "Kuruppu.pdf");

      let uploadResult = null;

      try {
        const uploadRes = await fetch(
          "https://kala.cubixsystems.com/api/upload_pdf.php",
          {
            method: "POST",
            body: formDataUpload
          }
        );

        const textRes = await uploadRes.text();
        console.log("Upload response:", textRes);

        try {
          uploadResult = JSON.parse(textRes);
        } catch {
          console.error("Invalid JSON from upload API");
        }
      } catch (err) {
        console.error("Upload error:", err);
      }

      // 🔄 STEP 4: OPEN WHATSAPP
      if (uploadResult && uploadResult.url) {
        Swal.update({
          title: "Opening WhatsApp...",
          text: "Sharing document 📲"
        });

        const phone = formData.phone;

        const message = encodeURIComponent(
          `Hello ${row.name},
  
  Your Kurippu is ready 📄
  
  ${uploadResult.url}`
        );

        const whatsappURL = `https://wa.me/91${phone}?text=${message}`;

        // small delay for better UX
        setTimeout(() => {
          window.open(whatsappURL, "_blank");
          Swal.close();
        }, 800);
      }
      else {
        Swal.fire("Warning", "PDF upload failed", "warning");
      }

      // RESET
      setEditId(null);
      handleSearch();

    } catch (err) {
      console.error("FINAL ERROR:", err);
      Swal.fire("Error", "Something went wrong", "error");
    }
  };



  const generateStyledPDF = async (row) => {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a5"
    });

    const formatDate = (dateString) => {
      const d = new Date(dateString);
      return `${String(d.getDate()).padStart(2, "0")}-${String(
        d.getMonth() + 1
      ).padStart(2, "0")}-${d.getFullYear()}`;
    };

    const formattedDate = formatDate(row.visit_date);

    try {
      const imgData = await getBase64FromUrl("/images/Astrologer.jpeg");

      doc.addImage(imgData, "JPEG", 0, 0, 148, 210);

      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);

      doc.text(`Date: ${formattedDate}`, 100, 40);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(12);

      const splitText = doc.splitTextToSize(row.prescription || "", 80);

      doc.text(splitText, 55, 70);

      return doc;
    } catch (err) {
      console.error("Image load failed", err);
      return doc;
    }
  };

  const getBase64FromUrl = async (url) => {
    const data = await fetch(url);
    const blob = await data.blob();

    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => resolve(reader.result);
    });
  };

  const generateExactPDFfromHTML = async (row) => {
    const formatDate = (dateString) => {
      const d = new Date(dateString);
      return `${String(d.getDate()).padStart(2, "0")}-${String(
        d.getMonth() + 1
      ).padStart(2, "0")}-${d.getFullYear()}`;
    };

    const formattedDate = formatDate(row.visit_date);

    // 👉 SAME HTML AS YOUR PRINT
    const htmlContent = `
      <div style="
        width:148mm;
        height:210mm;
        background-image:url('./images/Astrologer.jpeg');
        background-size:cover;
        position:relative;
        font-family: Tahoma;
      id="pdfContainer">
        <div style="
         
          top:220px;
          left:55px;
          width:80%;
        ">
        <h1>Sandheep Warrior</h1>
          <p style="text-align:right;">
            <strong>Date:</strong> ${formattedDate}
          </p>
  
          <p style="margin-top:30px;font-family:Noto Sans Malayalam">
            ${row.prescription || ""}
          </p>
        </div>
      </div>
    `;

    const container = document.getElementById("pdfContainer");
    container.innerHTML = htmlContent;

    const element = container.firstChild;

    const canvas = await html2canvas(element, {
      scale: 3,
      useCORS: true
    });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a5"
    });

    pdf.addImage(imgData, "PNG", 0, 0, 148, 210);

    return pdf;
  };





  const generatePDFAndSendWhatsApp = async (row) => {
    try {
      // ✅ STEP 1: Generate styled PDF
      const doc = await generateExactPDFfromHTML(row);

      // 👉 Convert to blob
      //const pdfBlob = doc.output("blob");

      const pdf = await generateExactPDFfromHTML(row);
      const pdfBlob = pdf.output("blob");

      // ============================
      // ☁️ UPLOAD
      // ============================
      const formDataUpload = new FormData();
      formDataUpload.append("file", pdfBlob, "kurippu.pdf");

      const uploadRes = await fetch(
        "https://kala.cubixsystems.com/api/upload_pdf.php",
        {
          method: "POST",
          body: formDataUpload
        }
      );

      let uploadResult = {};

      try {
        uploadResult = await uploadRes.json();
      } catch (e) {
        console.warn("Invalid JSON");
      }

      // ============================
      // 📲 WHATSAPP
      // ============================
      if (uploadResult && uploadResult.url) {
        const phone = form.phone;

        const message = encodeURIComponent(
          `Hello ${row.name},
  
  Your prescription is ready 📄
  
  Download here:
  ${uploadResult.url}`
        );

        const whatsappURL = `https://wa.me/91${phone}?text=${message}`;

        window.open(whatsappURL, "_blank");
      } else {
        // ❗ fallback
        doc.save("prescription.pdf");

        Swal.fire(
          "Warning",
          "PDF upload failed. Downloaded locally.",
          "warning"
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleCancel = () => {

    window.location.reload();
    setFormData({
      name: "",
      phone: "",
      age: "",
      sex: "",
      star: "",
      remarks: ""
    });

    setEditId(null);
  };

  const [form, setForm] = useState({
    name: "",
    phone: "",
    ageFrom: "",
    ageTo: "",
    caste: "",
    star: "",
    sex: "",
    fromDate: "",
    toDate: ""
  });

  const [data, setData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleEntryChange = (index, field, value) => {
    const updated = [...form.entries];
    updated[index][field] = value;

    setForm({ ...form, entries: updated });
  };

  const handleSearchChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) {
      setForm({ ...form, phone: value });
    }
  };



  const handleSearch = async () => {
    const error = validateForm();

    if (error) {
      Swal.fire({
        icon: "warning",
        title: "Search",
        text: error
      });
      return;

    }
    setShowTable(false);
    setLoading(true);

    try {
      const res = await fetch(
        `https://kala.cubixsystems.com/api/search_patient.php?phone=${form.phone}`
      );
      const result = await res.json();

      if (result.believer) {
        setFormData(result.believer);
        setData(result.visits); // visit history
      } else {
        Swal.fire("Believer", "No record found", "info");
        // setFormData({ ...formData, phone: form.phone });
        // setData([]);
        window.location.reload();

      }

      setShowTable(true);
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  const handleEdit = (row) => {
    setFormData({
      ...formData,
      prescription: row.prescription,
      // name: row.name,
      // bname: row.bname,
      remarks: row.remarks || "",
    });

    setEditId(row.id); // store visit id
  };



  const handlePrint = (row) => {
    const printWindow = window.open("", "_blank");

    const name = row.name || formData.name || "";
    const bname = row.bname || formData.bname || "";
    const star = row.star || formData.star || "";
    const age = row.age || formData.age || "";
    const native = row.native || formData.native || "";
    const prescription = row.prescription || "";

    // 📅 DATE FORMAT
    const formatPrintDate = (dateString) => {
      if (!dateString) return "";

      const d = new Date(dateString.replace(" ", "T"));

      return new Intl.DateTimeFormat("en-IN", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      }).format(d);
    };

    const formattedDate = formatPrintDate(row.visit_date);

    // 🔥 HEIGHT-BASED SPLIT (PERFECT FIX)
    const splitByHeight = (text, heights) => {
      const words = text.split(" ");
      const pages = [];

      const temp = document.createElement("div");

      temp.style.position = "absolute";
      temp.style.visibility = "hidden";
      temp.style.width = "480px";
      temp.style.fontFamily = "Noto Sans Malayalam, Tahoma";
      temp.style.fontSize = "14px";
      temp.style.lineHeight = "1.3";
      temp.style.whiteSpace = "pre-wrap";
      temp.style.wordBreak = "break-word";

      document.body.appendChild(temp);

      let current = "";
      let pageIndex = 0;

      words.forEach((word) => {
        const test = current + word + " ";
        temp.innerText = test;

        const maxHeight =
          pageIndex === 0 ? heights.firstPage : heights.otherPages;

        if (temp.offsetHeight > maxHeight) {
          pages.push(current.trim());
          current = word + " ";
          pageIndex++;
        } else {
          current = test;
        }
      });

      if (current.trim()) {
        pages.push(current.trim());
      }

      document.body.removeChild(temp);

      return pages;
    };

    // 🔥 PERFECT HEIGHTS (A5 OPTIMIZED)
    const prescriptionPages = splitByHeight(prescription, {
      firstPage: 360,   // smaller due to name/date block
      otherPages: 450,  // full usable height
    });

    // 🖨 PRINT WINDOW
    printWindow.document.write(`
  <html>
  <head>
    <title>Print</title>
  
    <style>
      @page {
        size: A5;
        margin: 0;
      }
  
      body {
        margin: 0;
        font-family: "Noto Sans Malayalam", Tahoma;
      }
  
      /* HEADER */
      .header {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 220px;
        background-image: url('/images/Astrologer.jpeg');
        background-size: cover;
        background-repeat: no-repeat;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
  
      /* FOOTER */
      .footer {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 50px;
        text-align: center;
        font-size: 12px;
        background: black;
        color: white;
      }
  
      /* PAGE */
      .page {
        page-break-after: always;
        break-after: page;
        height: 100vh;
        box-sizing: border-box;
  
        padding-top: 220px;
        padding-bottom: 50px;
        padding-left: 55px;
        padding-right: 40px;
      }
  
      /* PRESCRIPTION */
      .prescription {
        margin-top: 20px;
        white-space: pre-wrap;
        word-break: break-word;
        line-height: 1.3;
        font-size: 14px;
        // border: 1px solid silver;
        // padding: 10px;
      }
  
    </style>
  </head>
  
  <body>
  
    <!-- HEADER -->
    <div class="header"></div>
  
    <!-- FOOTER -->
    <div class="footer">
      <p>
        Time: 9 am to 6 pm | ഞായർ അവധി | Contact:
        <span style="font-size:12pt;">9946 36 22 99, 62838 36 22 99</span>
      </p>
    </div>
  
    ${prescriptionPages
        .map(
          (chunk, index) => `
        <div class="page">
  
          ${index === 0
              ? `
            <p style="text-align:right;">
              <strong>Date:</strong> ${formattedDate}
            </p>
  
            <p style="margin-top:30px">
              ${native} ${bname}<br/>
              ${star} ${name}, ${age} വയസ്സ്
            </p>
          `
              : ``
            }
  
          <div class="prescription">
  ${chunk}
          </div>
  
        </div>
      `
        )
        .join("")}
  
    <script>
      window.onload = function() {
        window.print();
        setTimeout(() => window.close(), 500);
      };
    </script>
  
  </body>
  </html>
  `);

    printWindow.document.close();
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This visit will be deleted",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await fetch(
            `https://kala.cubixsystems.com/api/delete_visit.php?id=${id}`
          );
          const data = await res.json();

          if (data.success) {
            Swal.fire("Deleted!", "Visit removed", "success");
            handleSearch(); // refresh
          }
        } catch (err) {
          console.error(err);
        }
      }
    });
  };

  const formatDate = (dateString) => {
    const dateObj = new Date(dateString);

    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const exportToExcel = () => {
    const exportData = data.map((row, i) => ({
      "Sl No": i + 1,
      RegNo: row.regNo,
      Name: row.name,
      Caste: row.caste,
      Age: row.age,
      Height: row.height,
      Star: row.star,
      Dhosham: row.dhosham,
      Qualification: row.qualification,
      Occupation: row.job,
      Native: row.native,
      Phone: row.phone
      //Date: formatDate(row.date),
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Search Results");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });

    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "Report.xlsx");
  };

  const exportToPDF = () => {
    const doc = new jsPDF("landscape", "mm", "a4");

    const tableColumn = [
      "Sl No",
      "Reg No",
      "Name",
      "Caste",
      "Age",
      "Height",
      "Star",
      "Dhosham",
      "Qualification",
      "Occupation",
      "Native",
      "Phone"

    ];

    const tableRows = data.map((row, i) => [
      i + 1,
      row.regNo,
      row.name,
      row.caste,
      row.age,
      row.height,
      row.star,
      row.dhosham,
      row.qualification,
      row.job,
      row.native,
      row.phone,
      row.phone,
      // formatDate(row.date)
    ]);

    doc.text("", 14, 10);

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 20
    });

    doc.save("Report.pdf");
  };

  // Language Selection
  const [text, setText] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedLang, setSelectedLang] = useState("ml");
  const [showDropdown, setShowDropdown] = useState(false);

  const debounceRef = useRef(null);
  const inputRef = useRef(null);

  // 🔹 Fetch Suggestions (Debounced)
  useEffect(() => {
    clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      fetchSuggestions();
    }, 300);

    return () => clearTimeout(debounceRef.current);
  }, [formData.prescription, selectedLang]); // ✅ FIXED

  const fetchSuggestions = async () => {
    const currentText = formData.prescription || "";
    const cursorPos = inputRef.current?.selectionStart || 0;

    // ✂️ Get text before cursor
    const textBeforeCursor = currentText.slice(0, cursorPos);

    // 🔍 Get current word near cursor
    const match = textBeforeCursor.match(/(\S+)$/);
    const lastWord = match ? match[0] : "";

    if (!lastWord.trim()) {
      setSuggestions([]);
      setShowDropdown(false);
      return;
    }

    if (selectedLang === "en") {
      setSuggestions([]);
      setShowDropdown(false);
      return;
    }

    try {
      let response = await fetch(
        `https://inputtools.google.com/request?text=${lastWord}&itc=${selectedLang}-t-i0-und&num=5`
      );

      let data = await response.json();

      if (data[0] === "SUCCESS") {
        setSuggestions(data[1][0][1]);
        setShowDropdown(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // 🔹 Handle Space (Auto Convert)
  const handleKeyDown = async (e) => {
    const currentText = formData.prescription || "";
    const cursorPos = e.target.selectionStart;

    if (e.key === "Enter") {
      setShowDropdown(false);
      return;
    }

    if (e.key === " ") {
      e.preventDefault();

      // ✂️ Split text at cursor
      const before = currentText.slice(0, cursorPos);
      const after = currentText.slice(cursorPos);

      // 🔍 Find word before cursor
      const match = before.match(/(\S+)$/);
      const lastWord = match ? match[0] : "";

      if (!lastWord) {
        setFormData({
          ...formData,
          prescription: before + " " + after,
        });
        return;
      }

      // ✅ ENGLISH → no conversion
      if (selectedLang === "en") {
        setFormData({
          ...formData,
          prescription: before + " " + after,
        });
        return;
      }

      try {
        let response = await fetch(
          `https://inputtools.google.com/request?text=${lastWord}&itc=${selectedLang}-t-i0-und&num=5`
        );

        let data = await response.json();

        let converted = lastWord;

        if (
          data[0] === "SUCCESS" &&
          data[1]?.[0]?.[1]?.length > 0
        ) {
          converted = data[1][0][1][0];
        }

        // 🔁 Replace only that word
        const newBefore = before.replace(/(\S+)$/, converted);

        setFormData({
          ...formData,
          prescription: newBefore + " " + after,
        });

      } catch (err) {
        console.error(err);
      }

      setSuggestions([]);
      setShowDropdown(false);
    }
  };

  // 🔹 Click Suggestion
  const selectSuggestion = (value) => {
    const currentText = formData.prescription || "";
    const cursorPos = inputRef.current.selectionStart;

    const before = currentText.slice(0, cursorPos);
    const after = currentText.slice(cursorPos);

    const newBefore = before.replace(/(\S+)$/, value);

    setFormData({
      ...formData,
      prescription: newBefore + " " + after,
    });

    setSuggestions([]);
    setShowDropdown(false);

    inputRef.current.focus();
  };



  return (
    <div className="container-fluid p-0">
      <div className="d-flex" style={{ height: "100vh" }}>
        <div
          className="top-0 start-0 p-2 fs-3 rounded shadow-sm"
          style={{
            zIndex: 999,
            cursor: "pointer",
            position: "fixed",
            left: open ? "350px" : "60px",
            top: "0",
            transition: "left 0.3s ease"
          }}
          onClick={() => setOpen(!open)}
        >
          <span className="displaysidemenu" style={{ position: "absolute", right: "-10px" }}>
            ☰
          </span>
        </div>
        <div
          className="border-end leftcolor"
          style={{
            width: open ? "350px" : "0",
            overflow: "hidden",
            transition: "0.3s ease"
          }}
        >
          {open && (
            <div className="p-3">
              <AdminLeft />
            </div>
          )}
        </div>

        {/* RIGHT CONTENT */}
        <div
          className="p-4"
          style={{
            width: open ? "calc(100% - 350px)" : "100%",
            transition: "0.3s ease",
            paddingLeft: "30px"
          }}
        >
          <TopBanner />
          <div className="area mt-4" >
            <h2></h2>

            {/* Inputs */}
            <div className="mb-2">
              {/* <input
                className="form-control- mb-2"
                name="name"
                placeholder="Name"
                onChange={handleChange}
              /> */}
              <input
                className="form-control mb-2"
                name="phone"
                placeholder="Enter Phone Number"
                value={form.phone}
                maxLength={10}
                onChange={handleSearchChange}
              />
              {/* <input
                className="form-control- mb-2"
                name="ageFrom"
                placeholder="Age From"
                type="number"
                onChange={handleChange}
              />
              <input
                className="form-control- mb-2"
                name="ageTo"
                placeholder="Age To"
                type="number"
                onChange={handleChange}
              />
              <input
                className="form-control- mb-2"
                name="caste"
                placeholder="Caste"
                onChange={handleChange}
              /> */}

              {/* Star Dropdown */}
              {/* <select
                className="form-control- mb-2"
                name="star"
                onChange={handleChange}
              >
                <option value="">Select Star</option>
                <option>Aswathy</option>
                <option>Bharani</option>
                <option>Karthika</option>
                <option>Rohini</option>
                <option>Makayiram</option>
                <option>Thiruvathira</option>
                <option>Punartham</option>
                <option>Pooyam</option>

                <option>Aayilyam</option>
                <option>Makham</option>
                <option>Pooram</option>
                <option>Uthram</option>
                <option>Atham</option>
                <option>Chihira</option>
                <option>Chothi</option>
                <option>Visaakam</option>
                <option>Anizham</option>
                <option>Thrikketta</option>
                <option>Moolam</option>
                <option>Pooraadam</option>
                <option>Uthraadam</option>
                <option>Thiruvonam</option>
                <option>Avittam</option>
                <option>Chathayam</option>
                <option>Pooruruttathi</option>
                <option>Uthrattathi</option>
                <option>Revathi</option>

             </select> */}

              {/* Sex */}
              {/* <select
                className="form-control- mb-2"
                name="sex"
                onChange={handleChange}
              >
                <option value="">Sex</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select> */}

              {/* Date */}
              {/* <input
                className="form-control- mb-2"
                type="date"
                name="fromDate"
                onChange={handleChange}
              />
              <input
                className="form-control- mb-2"
                type="date"
                name="toDate"
                onChange={handleChange}
              /> */}
              <br />
              <button
                style={{ background: '#004962ff', cursor: 'pointer' }}
                className="btn btn-primary mb-2"
                onClick={handleSearch}
              >
                Search
              </button> 
              <br />
              <span style={{color:'black'}}>(Demo Number: 9446775551)</span>

              {/* <button
                className="btn  mb-2"
                onClick={exportToExcel}
                style={{ marginLeft: '10px',background:'white',border:'1px solid green',color:'black',cursor:'pointer' }}
              >
                Export to Excel
              </button>
              <button
                className="btn mb-2"
                onClick={exportToPDF}
                style={{ marginLeft: '10px',background:'white',border:'1px solid green', color:'black',cursor:'pointer'}}
              >
                Export to PDF
              </button> */}

              {loading && <p>Loading...</p>}
            </div>

            {/* TABLE (only after search) */}
            <div style={{ height: '70vh', overflow: 'auto' }}>

              {showTable && (
                <div style={{ height: '100vh', overflow: 'auto' }}>
                  <div className="row">

                    {/* LEFT SIDE FORM */}
                    <div className="col-md-7" style={{ padding: '30px', borderRight: '1px groove silver' }}>
                      <div className="row">
                        <div className="col-md-6">
                          <table className="table">
                            <tr>
                              <td style={{ width: '2%' }}><i class="fa fa-user"></i></td>
                              {/* <td>{formData.name}</td> */}
                              <td>Ratnakarn Meonon</td>
                            </tr>
                            <tr>
                              <td style={{ width: '2%' }}> <i class="fa fa-phone"></i></td>
                              {/* <td>{formData.phone} </td> */}
                              <td>9446775551</td>
                            </tr>
                            <tr>
                              <td style={{ width: '2%' }}><i class="fa fa-star"></i></td>
                              {/* <td> {formData.age}</td> */}
                              <td>Mohiniyattom</td>
                            </tr>
                            <tr>
                              <td style={{ width: '2%' }}><i class="fa fa-calendar"></i></td>
                              {/* <td> {formData.age}</td> */}
                              <td>1 Year</td>
                            </tr>
                          </table>

                          {/* <table className="table">

                            <tr>
                              <td style={{ width: '2%' }}><i class="fa fa-user"></i></td>
                              <td>{formData.name}</td>

                              <td style={{ width: '2%' }}> <i class="fa fa-phone"></i></td>
                              <td>{formData.phone} </td>

                              <td style={{ width: '2%' }}><i class="fa fa-calendar"></i></td>
                              <td> {formData.age}</td>

                              <td style={{ width: '2%' }}> <i class="fa fa-user"></i></td>
                              <td>{formData.sex}</td>
                              <td style={{ width: '2%' }}><i class="fa fa-star"></i></td>
                              <td>{formData.star}</td>
                            </tr>
                            <tr>
                              <td style={{ width: '2%' }}> <i class="fa fa-phone"></i></td>
                              <td>{formData.phone} </td>
                            </tr>
                            <tr>
                              <td style={{ width: '2%' }}><i class="fa fa-calendar"></i></td>
                              <td> {formData.age}</td>
                            </tr>
                            <tr>
                              <td style={{ width: '2%' }}> <i class="fa fa-user"></i></td>
                              <td>{formData.sex}</td>
                            </tr>
                            <tr>
                              <td style={{ width: '2%' }}><i class="fa fa-star"></i></td>
                              <td>{formData.star}</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td></td>
                            </tr>
                          </table> */}
                        </div>
                        <div className="col-md-6">
                          <div style={{ border: '1px solid silver',  padding: '10px' }}>
                            <table className="table">
                              <tr>
                                <td style={{ width: '50%' }}>Course Fee</td>
                                {/* <td>{formData.name}</td> */}
                                <td><i class="fa fa-rupee"></i> 80000</td>
                              </tr>
                              <tr>
                                <td > Total Fee Pad</td>
                                {/* <td>{formData.phone} </td> */}
                                <td><i class="fa fa-rupee"></i> 60000</td>
                              </tr>
                              <tr>
                                <td >Balance</td>
                                {/* <td> {formData.age}</td> */}
                                <td style={{ display: "flex", alignItems: "center", gap: "6px" }}>

                                  <i className="fa fa-rupee"></i>
                                  <input
                                    name="name"
                                    type="text"
                                    value="20000"
                                    placeholder="Enter Amount"
                                    className="form-control"
                                  // style={{ width: "auto" }}
                                  />

                                </td>
                              </tr>
                              <tr>
                                <td></td>
                                <td>
                                  <div>
                                    <button className="btn btn-warning w-50 mr-1">
                                      {editId ? "Update" : "PAY"}
                                    </button>
                                    {/* <button className="btn btn-warning w-50 mr-1" onClick={handleSave}>
                                      {editId ? "Update" : "PAY"}
                                    </button> */}
                                    {/* <button className="btn btn-secondary w-30 mb-2" onClick={handleCancel}>
                                      Cancel
                                    </button> */}
                                  </div>
                                </td>
                              </tr>

                            </table>
                          </div>
                        </div>
                      </div>



                      <input
                        name="name"
                        type="hidden"
                        value={formData.name}
                        placeholder="Name"
                        className="form-control mb-2"
                      />

                      <input
                        name="phone"
                        type="hidden"
                        placeholder="Phone Number"
                        value={formData.phone}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "");
                          if (value.length <= 10) {
                            setFormData({ ...formData, phone: value });
                          }
                        }}
                        className="form-control mb-2"
                      />

                      <input
                        name="age"
                        type="hidden"
                        placeholder="Age"
                        value={formData.age}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "");
                          if (value.length <= 2) {
                            setFormData({ ...formData, age: value });
                          }
                        }}
                        className="form-control mb-2"
                      />

                      {/* Gender */}
                      <div style={{ display: 'none' }}>
                        {["Male", "Female"].map((s) => (
                          <label key={s} style={{ color: 'black' }}>
                            <input
                              type="radio"
                              name="sex"
                              value={s}
                              checked={formData.sex === s}
                              onChange={handleChange}
                              style={{ marginLeft: '10px', marginRight: '6px', marginTop: '15px' }} />
                            {s}
                          </label>
                        ))}
                      </div>

                      {/* Star */}
                      <select
                        name="star"
                        value={formData.star}
                        onChange={handleChange}
                        className="form-control mt-2" style={{ display: 'none' }}
                      >
                        <option value="">Select Star</option>
                        {[
                          "Aswathy", "Bharani", "Karthika", "Rohini", "Makeeyram"
                        ].map((s) => (
                          <option key={s}>{s}</option>
                        ))}
                      </select>
                      {/* <textarea style={{ height: '250px' }}
                        name="prescription"
                        placeholder="ഉപദേശം നൽകുക"
                        value={formData.prescription}
                        onChange={(e) =>
                          setFormData({ ...formData, prescription: e.target.value })
                        }
                        className="form-control mt-2" required
                      ></textarea> */}
                      <input
                        placeholder="Remarks"
                        name="prescription-"
                        // value={formData.prescription}
                        // onChange={handleEntryChange}
                        className="form-control mt-2" style={{ display: 'none' }}
                      />
                      {/* <div ref={editorRef} style={{ height: "400px" }}></div> */}


                      {/* <textarea value={formData.prescription} name="prescription" style={{height:'350px'}} className="form-control"></textarea> */}


                      {/* <Editor
                        apiKey="vwc2250gw344g249up4k201omsyv5ahfny97oil1nr6f1i1p" // works free
                        value={formData.prescription}
                        init={{
                          height: 450,
                          menubar: false,
                          plugins: [
                            "lists",
                            "link",
                            "preview"
                          ],
                          toolbar: 'undo redo | tinymceai-chat tinymceai-quickactions tinymceai-review | blocks fontfamily fontsize | bold italic underline strikethrough | link media table mergetags | addcomment showcomments | spellcheckdialog a11ycheck typography uploadcare | align lineheight | checklist numlist bullist indent outdent | emoticons charmap | removeformat',
                        }}
                        onEditorChange={(content) =>
                          setFormData({ ...formData, prescription: content })
                        }
                      /> */}




                      {/* <select
                        value={selectedLang}
                        onChange={(e) => setSelectedLang(e.target.value)}
                        style={{ marginBottom: "10px", padding: "8px" }}
                      >
                        <option value="ml">Malayalam (മലയാളം)</option>
                        <option value="hi">Hindi (हिंदी)</option>
                        <option value="en">English (English)</option>
                        <option value="ta">Tamil (தமிழ்)</option>
                        <option value="te">Telugu (తెలుగు)</option>
                        <option value="kn">Kannada (ಕನ್ನಡ)</option>
                        <option value="bn">Bengali (বাংলা)</option>
                        <option value="gu">Gujarati (ગુજરાતી)</option>
                        <option value="mr">Marathi (मराठी)</option>
                        <option value="pa">Punjabi (ਪੰਜਾਬੀ)</option>
                        <option value="or">Odia (ଓଡ଼ିଆ)</option>
                      </select> */}

                      <div style={{ position: "relative", border: '1px solid silver' }}>
                        {/* <textarea className="form-control"
                          ref={inputRef}
                          value={formData.prescription}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              prescription: e.target.value,
                            })
                          }
                          onKeyDown={handleKeyDown} // ✅ ADD THIS
                          style={{
                            width: "100%",
                            height: "450px",
                            padding: "10px",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                            resize: "vertical",
                            fontSize: "14px",
                            outline: "none", fontFamily: 'anek malayalam', color: 'black', fontSize: '12pt', fontWeight: '500'
                          }}
                          placeholder="ഉപദേശം നൽകുക..."
                        /> */}

                        {/* 🔽 Suggestions Dropdown */}
                        {/* {showDropdown && suggestions.length > 0 && (
                          <div
                            style={{
                              position: "fixed",
                              top: '0',
                              right: '0',
                              width: "50%",
                              background: "#ffffff",
                              border: "1px solid #ddd",
                              borderRadius: "8px",
                              Height: "220px",
                              overflowY: "auto",
                              zIndex: 9999,
                              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                            }}
                          >
                            {suggestions.map((item, index) => (
                              <div
                                key={index}
                                onClick={() => selectSuggestion(item)}
                                style={{
                                  padding: "12px 16px",
                                  cursor: "pointer",
                                  fontSize: "18px",           
                                  color: "#000",             
                                  fontWeight: "500",
                                  borderBottom: "1px solid #f0f0f0",
                                }}
                                onMouseOver={(e) => {
                                  e.target.style.background = "#f5f5f5";
                                }}
                                onMouseOut={(e) => {
                                  e.target.style.background = "#fff";
                                }}
                              >
                                {item}
                              </div>
                            ))}
                          </div>
                        )} */}
                      </div>




                      {/* <textarea
                        value={formData.prescription}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            prescription: e.target.value,
                          })
                        }
                        style={{
                          width: "100%",
                          height: "450px",
                          padding: "10px",
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                          resize: "vertical",
                          fontSize: "14px",
                          outline: "none",
                        }}
                        placeholder="ഉപദേശം നൽകുക..."
                      /> */}



                      {/* <div className="mt-3">
                        <button className="btn btn-warning w-50 mb-2 mr-1" onClick={handleSave}>
                          {editId ? "Update" : "Save"}
                        </button>
                        <button className="btn btn-secondary w-30 mb-2" onClick={handleCancel}>
                          Cancel
                        </button>
                      </div> */}


                    </div>

                    {/* RIGHT SIDE TABLE */}
                    <div className="col-md-5" style={{ padding: '25px' }}>

                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th style={{ width: '2%' }}>No</th>
                            <th style={{ width: '38%' }}>Bill Date</th>
                            <th style={{ width: '30%' }}>Amount</th>
                            <th style={{ width: '30%' }}></th>
                          </tr>
                        </thead>

                        <tbody>
                          {data.length > 0 ? (
                            data.map((row, i) => (
                              <tr key={row.id}>
                                <td>{i + 1}</td>
                                {/* <td>{row.visit_date}</td> */}
                                <td>
                                  {row.visit_date
                                    ? new Intl.DateTimeFormat("en-IN", {
                                      timeZone: "Asia/Kolkata",
                                      day: "2-digit",
                                      month: "2-digit",
                                      year: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: true
                                    }).format(new Date(row.visit_date.replace(" ", "T")))
                                    : ""}
                                </td>
                                <td>
                                  <i class="fa fa-rupee"></i> 60000
                                  {/* {row.prescription} */}
                                  {/* <button
                                    className="btn btn-sm btn-primary me-2"
                                    onClick={() => handleEdit(row)}
                                    style={{ padding: '6px', border: 'none', marginRight: '5px', background: 'white', color: 'maroon', border: '1px solid maroon', cursor: 'pointer' }} >
                                    <i class="fa fa-eye"></i>
                                  </button> */}
                                </td>
                                <td>
                                  {/* <button
                                    className="btn btn-sm btn-primary me-2"
                                    onClick={() => handleEdit(row)}
                                    style={{ padding: '6px', border: 'none', marginRight: '5px', background: 'white', color: 'maroon', border: '1px solid maroon', cursor: 'pointer' }} >
                                    <i class="fa fa-edit"></i>
                                  </button> */}

                                  {/* <button
                                    className="btn btn-sm btn-danger"
                                    onClick={() => handleDelete(row.id)}
                                  >
                                    <i class="fa fa-trash"></i>
                                  </button> */}

                                  <button  className=" btn-default" style={{ padding: '6px', border: 'none', cursor: 'pointer', border: '1px solid silver' }}><i class="fa fa-print"></i></button>
                                  {/* <button onClick={() => handlePrint(row)} className=" btn-default" style={{ padding: '6px', border: 'none', cursor: 'pointer', border: '1px solid silver' }}><i class="fa fa-print"></i></button> */}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8">No results found</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                  </div>
                </div>
              )}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}